var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElement, SurveyQuestionUncontrolledElement } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { CharacterCounterComponent } from "./components/character-counter";
import { TextAreaComponent } from "./components/text-area";
var SurveyQuestionComment = /** @class */ (function (_super) {
    __extends(SurveyQuestionComment, _super);
    function SurveyQuestionComment(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionComment.prototype.renderCharacterCounter = function () {
        var counter = null;
        if (!!this.question.getMaxLength()) {
            counter = React.createElement(CharacterCounterComponent, { counter: this.question.characterCounter, remainingCharacterCounter: this.question.cssClasses.remainingCharacterCounter });
        }
        return counter;
    };
    SurveyQuestionComment.prototype.renderElement = function () {
        if (this.question.isReadOnlyRenderDiv()) {
            return React.createElement("div", null, this.question.value);
        }
        var counter = this.renderCharacterCounter();
        var textAreaModel = this.props.question.textAreaModel;
        return (React.createElement(React.Fragment, null,
            React.createElement(TextAreaComponent, { viewModel: textAreaModel }),
            counter));
    };
    return SurveyQuestionComment;
}(SurveyQuestionUncontrolledElement));
export { SurveyQuestionComment };
var SurveyQuestionCommentItem = /** @class */ (function (_super) {
    __extends(SurveyQuestionCommentItem, _super);
    function SurveyQuestionCommentItem(props) {
        var _this = _super.call(this, props) || this;
        _this.textAreaModel = _this.getTextAreaModel();
        return _this;
    }
    SurveyQuestionCommentItem.prototype.canRender = function () {
        return !!this.props.question;
    };
    SurveyQuestionCommentItem.prototype.getTextAreaModel = function () {
        return this.props.question.commentTextAreaModel;
    };
    SurveyQuestionCommentItem.prototype.renderElement = function () {
        var question = this.props.question;
        if (question.isReadOnlyRenderDiv()) {
            var comment = this.textAreaModel.getTextValue() || "";
            return React.createElement("div", null, comment);
        }
        return (React.createElement(TextAreaComponent, { key: this.getKey(), viewModel: this.textAreaModel }));
    };
    SurveyQuestionCommentItem.prototype.getKey = function () { return undefined; };
    return SurveyQuestionCommentItem;
}(ReactSurveyElement));
export { SurveyQuestionCommentItem };
var SurveyQuestionCommentValueItem = /** @class */ (function (_super) {
    __extends(SurveyQuestionCommentValueItem, _super);
    function SurveyQuestionCommentValueItem(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionCommentValueItem.prototype.getTextAreaModel = function () {
        return this.props.question.getCommentTextAreaModel(this.props.item);
    };
    SurveyQuestionCommentValueItem.prototype.getKey = function () { return this.props.item.uniqueId; };
    return SurveyQuestionCommentValueItem;
}(SurveyQuestionCommentItem));
export { SurveyQuestionCommentValueItem };
ReactQuestionFactory.Instance.registerQuestion("comment", function (props) {
    return React.createElement(SurveyQuestionComment, props);
});
